const testimonials = [
  {
    quote: 'Dr. Leder — I appreciate you. Doctors, I\'ve come across many, but none as real and unique as you. You care and you show it. Thank you for treating the person I am as well as the patient you see before you.',
    name: 'N.B.',
    condition: 'Hormonal Health Patient',
    rating: 5,
  },
  {
    quote: 'I want to thank you for helping and properly diagnosing my daughter. It has been such a hard time for her and heartbreaking for me. I have gone with her to so many doctors without any relief of her issues. I know G-d has used you to help her.',
    name: 'D.M.',
    condition: 'Parent of Spectrum Disorder Patient',
    rating: 5,
  },
  {
    quote: 'After years of being told my labs were "normal," Dr. Leder found the underlying hormonal imbalances driving my fatigue and weight gain within the first visit. Within 3 months I felt like a completely different person. She changed my life.',
    name: 'S.K.',
    condition: 'Thyroid & Weight Loss Program',
    rating: 5,
  },
  {
    quote: 'The IV chelation therapy Dr. Leder recommended made a tremendous difference in my energy levels and cardiovascular markers. She explained every step clearly and made me feel completely at ease. Truly exceptional care.',
    name: 'R.T.',
    condition: 'Chelation Therapy Patient',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Patient Outcomes</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-teal-950 mb-5">
            Real Patients. Real Results.
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Words from patients whose lives have been genuinely transformed through Dr. Leder's functional medicine approach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-teal-50 border border-teal-100 rounded-lg p-8">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <div key={si} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                  </div>
                ))}
              </div>
              {/* Quote */}
              <blockquote className="text-teal-900 text-base leading-relaxed mb-6 font-heading italic">
                "{t.quote}"
              </blockquote>
              {/* Attribution */}
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-700 rounded-full">
                  <i className="ri-user-line text-white text-lg"></i>
                </div>
                <div>
                  <p className="text-teal-900 font-semibold text-sm">{t.name}</p>
                  <p className="text-teal-600 text-xs">{t.condition}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Aggregate Trust Signal */}
        <div className="mt-10 bg-teal-900 text-white rounded-lg p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="font-heading text-3xl font-bold text-white mb-1">40+ Years</p>
            <p className="text-teal-300 text-sm">of trusted functional medicine care in Bergen County, NJ</p>
          </div>
          <div className="w-px h-12 bg-teal-700 hidden md:block"></div>
          <div className="text-center">
            <p className="font-heading text-3xl font-bold text-white mb-1">Thousands</p>
            <p className="text-teal-300 text-sm">of patients helped across the tri-state area</p>
          </div>
          <div className="w-px h-12 bg-teal-700 hidden md:block"></div>
          <div className="text-center md:text-right">
            <div className="flex items-center gap-1 justify-center md:justify-end mb-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-lg"></i>
                </div>
              ))}
            </div>
            <p className="text-teal-300 text-sm">Consistently top-rated in Hackensack, NJ</p>
          </div>
        </div>
      </div>
    </section>
  );
}
